import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface SingleApiCallStateData {
  singleApiCall: {
    values: string[];
  };
}
export interface SingleApiCallState {
  values: string[];
}

const initialState: SingleApiCallState = {
  values: ['Global Interactive', 'Private Interactive', 'Shared Interactive'],
};

const singleApiCallSlice = createSlice({
  name: 'singleApiCall',
  initialState,
  reducers: {
    addType: (state, action: PayloadAction<string>) => {
      state.values.push(action.payload);
    },
    removeType: (state, action: PayloadAction<string>) => {
      state.values = state.values.filter((item) => item !== action.payload);
    },
    reset: () => initialState,
  },
});

export const { addType, removeType, reset } = singleApiCallSlice.actions;
export default singleApiCallSlice.reducer;
